import React from 'react'
import injectSheet from 'react-jss'
import NumberFormat from 'react-number-format'

const NumberField = (props) => {
  const {
    classes,
    displayType,
    id,
    handleChange,
    handleSubmit,
    min,
    max,
    name,
    placeholder,
    suffix,
    step,
    value,
  } = props

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSubmit()
    }
  }

  return (
    <NumberFormat
      className={classes.inputField}
      displayType={displayType}
      id={id}
      min={min}
      max={max}
      name={name}
      onValueChange={handleChange}
      onKeyPress={handleKeyPress}
      placeholder={placeholder}
      suffix={suffix}
      step={step}
      thousandSeparator="'"
      type="tel"
      value={value}
    />
  )
}

const styles = theme => ({
  inputField: {
    display: 'block',
    height: '100%',
    width: '100%',
    backgroundColor: theme.colors.main_2,
    color: theme.colors.secondary_3b,
    borderColor: theme.colors.secondary_3a,
    borderWidth: '3px',
    borderStyle: 'solid',
    borderRadius: '5px',
    fontSize: '1em',
    textAlign: 'right',
    padding: `${theme.sizes.gutter / 4}px`,
    '&::placeholder': {
      color: theme.colors.secondary_3a,
    },
  },
})

export default injectSheet(styles)(NumberField)



// WEBPACK FOOTER //
// ./src/modules/core/components/numberField.jsx